import { Component } from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'
import Icon from '../assets'
import { BannerElementConfig, Position, TextAlignment } from './index.sync'
import Editor from '../../preact-components/editor'
import ImageUploadField from '@insided/destination/modules/Customization/configurator/image-upload-field'

interface Props extends BannerElementConfig{
  onChange: (state: State) => void
}

interface State {
  contentIsExtended: boolean
  imageIsExtended: boolean
  buttonsIsExtended: boolean
  contentTextAlignment: TextAlignment
  contentTitle: string
  contentDescription: string
  buttonsPrimaryText?: string
  buttonsPrimaryUrl?: string
  buttonsSecondaryText?: string
  buttonsSecondaryUrl?: string
  imagePosition: Position
  imageSrc: string
}

export const ALIGNMENTS = ['Left', 'Center', 'Right']
export const POSITION = ['Top', 'Bottom', 'Left', 'Right']

class BannerConfigurator extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      contentIsExtended: true,
      imageIsExtended: false,
      buttonsIsExtended: false,
      contentTextAlignment: props.content.textAlignment,
      contentTitle: props.content.title,
      contentDescription: props.content.description,
      buttonsPrimaryText: props.buttons?.primaryText,
      buttonsPrimaryUrl: props.buttons?.primaryUrl,
      buttonsSecondaryText: props.buttons?.secondaryText,
      buttonsSecondaryUrl: props.buttons?.secondaryUrl,
      imagePosition: props.image?.position ?? 'Top',
      imageSrc: props.image?.src ?? ''
    }

    this.notifyChanges = this.notifyChanges.bind(this)
  }

  notifyChanges() {
    this.props.onChange(this.state)
  }

  render() {
    const {
      contentIsExtended,
      imageIsExtended,
      buttonsIsExtended,
      contentTitle,
      contentTextAlignment,
      contentDescription,
      buttonsPrimaryText,
      buttonsPrimaryUrl,
      buttonsSecondaryText,
      buttonsSecondaryUrl,
      imagePosition,
      imageSrc
    } = this.state
    return (
      <div>
        <div className='widget-configurator_tab homepage-widget-configurator_tab-template'>
          <div className='widget-configurator_tab-header' onClick={() => this.setState({ contentIsExtended: !contentIsExtended })}>
            <div className='widget-configurator_tab-icon'>
              <Icon size={24} color='#2B3346' icon={contentIsExtended ? 'chevronDown' : 'chevronRight'} />
            </div>
            CONTENT
          </div>

          {
            contentIsExtended &&
              (
                <div className='widget-configurator_tab-content'>
                  <InputGroup title='Text Alignment'>
                    <select
                      name='textAlignment'
                      className='webmasterSelector'
                      onChange={(event) => {
                        this.setState({ contentTextAlignment: (event.target as HTMLSelectElement).value as TextAlignment }, this.notifyChanges)
                      }}
                    >
                      {ALIGNMENTS.map((alignment) => (
                        <option
                          key={alignment}
                          selected={contentTextAlignment === alignment}
                        >
                          {alignment}
                        </option>
                      ))}
                    </select>
                  </InputGroup>
                  <InputGroup
                    title='Title'
                    type='text'
                    onChange={(event) => {
                      this.setState({ contentTitle: event.target.value }, this.notifyChanges)
                    }}
                    value={contentTitle}
                  />
                  <div className='content_description'>
                    <label>Description</label>
                    <Editor
                      isControl
                      disableFileAttachments
                      disableMentions
                      data={contentDescription}
                      CKEditor={false}
                      canHavePoll={false}
                      onChange={(content: string) => {
                        this.setState({ contentDescription: content }, this.notifyChanges)
                      }}
                    />
                  </div>
                </div>
              )
          }
        </div>
        <div className='widget-configurator_tab homepage-widget-configurator_tab-template'>
          <div className='widget-configurator_tab-header' onClick={() => this.setState({ imageIsExtended: !imageIsExtended })}>
            <div className='widget-configurator_tab-icon'>
              <Icon size={24} color='#2B3346' icon={imageIsExtended ? 'chevronDown' : 'chevronRight'} />
            </div>
            IMAGE
          </div>

          {
            imageIsExtended &&
            (
              <div className='widget-configurator_tab-content'>
                <InputGroup title='Image position'>
                  <select
                    name='imagePosition'
                    className='webmasterSelector'
                    onChange={(event) => {
                      this.setState({ imagePosition: (event.target as HTMLSelectElement).value as Position }, this.notifyChanges)
                    }}
                  >
                    {POSITION.map((position) => (
                      <option
                        key={position}
                        selected={imagePosition === position}
                      >
                        {position}
                      </option>
                    ))}
                  </select>
                </InputGroup>

                <InputGroup title='Image'>
                  <p>We recommend a minimum of 640*480px</p>
                  <ImageUploadField src={imageSrc} onChange={src => this.setState({ imageSrc: src }, this.notifyChanges)} />
                </InputGroup>
              </div>
            )
          }
        </div>
        <div className='widget-configurator_tab homepage-widget-configurator_tab-content'>
          <div className='widget-configurator_tab-header' onClick={() => this.setState({ buttonsIsExtended: !buttonsIsExtended })}>
            <div className='widget-configurator_tab-icon'>
              <Icon size={24} color='#2B3346' icon={buttonsIsExtended ? 'chevronDown' : 'chevronRight'} />
            </div>
            BUTTONS
          </div>
          {
            buttonsIsExtended &&
              (
                <div className='widget-configurator_tab-content'>
                  <InputGroup
                    title='Primary button text'
                    type='text'
                    placeholder='text'
                    onChange={(event) => {
                      this.setState({ buttonsPrimaryText: event.target.value }, this.notifyChanges)
                    }}
                    value={buttonsPrimaryText}
                  />
                  <InputGroup
                    title='Primary button URL'
                    type='url'
                    placeholder='https://example.com'
                    onChange={(event) => {
                      this.setState({ buttonsPrimaryUrl: event.target.value }, this.notifyChanges)
                    }}
                    value={buttonsPrimaryUrl}
                  />
                  <InputGroup
                    title='Secondary button text'
                    type='text'
                    placeholder='text'
                    onChange={(event) => {
                      this.setState({ buttonsSecondaryText: event.target.value }, this.notifyChanges)
                    }}
                    value={buttonsSecondaryText}
                  />
                  <InputGroup
                    title='Secondary button URL'
                    type='url'
                    placeholder='https://example.com'
                    onChange={(event) => {
                      this.setState({ buttonsSecondaryUrl: event.target.value }, this.notifyChanges)
                    }}
                    value={buttonsSecondaryUrl}
                  />
                </div>
              )
          }
        </div>
      </div>
    )
  }
}
export default BannerConfigurator
